// The ruled border every drawing sheet carries: a hairline frame around the viewport,
// numbered zones along the horizontal edges and lettered zones along the vertical ones.
const COLUMNS = ['1', '2', '3', '4', '5', '6', '7', '8'];
const ROWS = ['A', 'B', 'C', 'D', 'E', 'F'];

export default function SheetFrame() {
	return (
		<div aria-hidden='true' className='pointer-events-none fixed inset-[5px] z-50 border border-ink-line shadow-[0_0_0_5px_#11151b] sm:inset-[10px] sm:shadow-[0_0_0_10px_#11151b]'>
			{/* Horizontal edges: numbered zones. */}
			{[false, true].map(bottom => (
				<div key={`h-${bottom}`} className={`absolute inset-x-0 hidden sm:flex ${bottom ? 'bottom-0' : 'top-0'}`}>
					{COLUMNS.map((c, i) => (
						<span key={c} className='relative flex flex-1 justify-center'>
							{i > 0 && <span className={`absolute left-0 h-[9px] w-px bg-ink-line ${bottom ? 'bottom-[-10px]' : 'top-[-10px]'}`} />}
							<span className={`lettering absolute text-[0.55rem] leading-[10px] text-ink-faint ${bottom ? 'bottom-[-10px]' : 'top-[-10px]'}`}>{c}</span>
						</span>
					))}
				</div>
			))}
			{/* Vertical edges: lettered zones. */}
			{[false, true].map(right => (
				<div key={`v-${right}`} className={`absolute inset-y-0 hidden flex-col sm:flex ${right ? 'right-0' : 'left-0'}`}>
					{ROWS.map((r, i) => (
						<span key={r} className='relative flex flex-1 items-center'>
							{i > 0 && <span className={`absolute top-0 h-px w-[9px] bg-ink-line ${right ? 'right-[-10px]' : 'left-[-10px]'}`} />}
							<span className={`lettering absolute w-[10px] text-center text-[0.55rem] leading-none text-ink-faint ${right ? 'right-[-10px]' : 'left-[-10px]'}`}>{r}</span>
						</span>
					))}
				</div>
			))}
		</div>
	);
}
